import type { ActivityModule } from '../../core/activity';
import { mountSmallNumbers2 } from './ui';
import levelsData from './levels.json';
import './style.css';

export const smallNumbers2: ActivityModule = {
  id: 'smallnumbers2',
  title: 'Conte os pontos',
  description: 'Os dominós caem do céu. Conte os pontos e digite o total antes de chegar no chão!',
  ageMin: 5,
  ageMax: 9,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/smallnumbers2/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountSmallNumbers2,
};
